"use client";

import type { ReactNode } from "react";
import { ToastProvider } from "@/components/ui/toast";
import { ThemeProvider } from "@/components/theme-provider";

// Wrapper client racine — pose ThemeProvider (gère le dark mode runtime)
// et ToastProvider (toasts dispo sur toutes les pages, login inclus).
// La command palette est mountée plus bas dans `(admin)/_components/admin-shell.tsx`.

export function RootShell({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider>
      <ToastProvider>{children}</ToastProvider>
    </ThemeProvider>
  );
}
